import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { baseUrl } from '../config/Global';
import { getData } from '../utils/storage';
import { showToast } from '../components/Toast';
import Loader from '../components/Loader';

const Package = () => {
    const navigate = useNavigate();
    const [wait, setWait] = useState(false);
    const [data, setData] = useState([]);
    const [admin, setAdmin] = useState(null);
    const [sdata, setSData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [search, setSearch] = useState('');
    const scrollContainerRef = useRef(null);

    const fetchData = async (pageNumber) => {
        setLoading(true);
        try {
            const mydata = getData('data');
            const mytoken = getData('token');
            const response = await axios.get(`${baseUrl}/showPlans?page=${pageNumber}`);
            console.log(response.data, 'Package data response');

            if (response.data.status === 'ok') {
                if (pageNumber === 1) {
                    setData(response.data.plans);
                } else {
                    setData(prevData => [...prevData, ...response.data.plans]);
                }
                setHasMore(pageNumber < response.data.totalPages);
            }
        } catch (err) {
            console.error('Fetch data error:', err);
            showToast(err.message || 'Failed to fetch packages', 'error');
        } finally {
            setLoading(false);
            setWait(false);
        }
    };

    const fetchSingleData = async () => {
        setLoading(true);
        try {
            const mydata = getData('data');
            const userData = await axios.get(`${baseUrl}/users/get/${mydata?.id}`);
            const adminData = await axios.get(`${baseUrl}/owner/get`);

            if (userData?.data?.data?.plan_id) {
                const response = await axios.get(`${baseUrl}/plan/${userData?.data?.data?.plan_id}`);
                if (response.data.status === 'ok') {
                    setSData(response.data.plans);
                }
            }

            setAdmin(adminData.data?.data[0]);
        } catch (err) {
            console.error('Fetch single data error:', err);
            showToast(err.message || 'Failed to fetch user data', 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setWait(true);
        fetchData(1);
        fetchSingleData();
    }, []);

    const handleScroll = useCallback((e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100;

        if (isNearBottom && !loading && hasMore) {
            const nextPage = page + 1;
            setPage(nextPage);
            fetchData(nextPage);
        }
    }, [loading, hasMore, page]);

    const handlePackageSelect = (item) => {
        navigate('/payment', {
            state: {
                move: 'package',
                userData: item,
                admin: admin
            }
        });
    };

    const filteredData = data.filter(item =>
        item.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="bg-gradient-to-br from-gray-50 via-indigo-50 to-lime-50">
            {wait && <Loader />}

            {/* Background decoration */}
            <div className="absolute inset-0 h-100 w-100">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-lime-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse-slow"></div>
                <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gray-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse-slow"></div>
            </div>

            <div className="relative">
                {/* Header */}
                <div className="bg-white/80 backdrop-blur-lg shadow-lg border-b border-white/20">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex items-center justify-between h-16">

                            <div className="flex items-center">
                                <div className="w-28 h-10  rounded-lg flex items-center justify-center">
                                    <img src={require('../assets/logo.png')} />
                                </div>
                            </div>
                            <button
                                onClick={() => {
                                    // Clear local storage
                                    localStorage.clear();
                                    // Optionally clear session storage if used
                                    sessionStorage.clear();
                                    // Redirect to login page or home page
                                    navigate('/'); // Change this to your desired logout destination
                                }}
                                className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                    />
                                </svg>
                                <span className="font-medium">Logout</span>
                            </button>

                        </div>
                    </div>
                </div>

                {/* Content */}
                <div
                    className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 "
                //   ref={scrollContainerRef}
                //   onScroll={handleScroll}
                >
                    {/* Current Package Section */}
                    {sdata && (
                        <div className="mb-8 animate-fade-in">
                            <h2 className="text-2xl font-bold text-gray-800 mb-4">Current Package</h2>
                            <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl p-6 border border-white/20 transform hover:scale-105 transition-all duration-300">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-4">
                                        <div className="w-12 h-12 bg-[#a8e82f] rounded-full flex items-center justify-center">
                                            <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-bold text-gray-800">{sdata?.name}</h3>
                                            <p className="text-gray-600">Active Plan</p>
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <span className="text-3xl font-bold text-[#a8e82f]">${sdata?.price}</span>
                                        <p className="text-gray-500 text-sm">per month</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Search Bar */}
                    <div className="mb-6">
                        <div className="relative max-w-md">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </div>
                            <input
                                type="text"
                                className="w-full pl-10 pr-4 py-3 bg-white/80 backdrop-blur-lg border border-white/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-transparent transition-all duration-200"
                                placeholder="Search packages..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Packages Section */}
                    <div className="mb-6">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6">Available Packages</h2>

                        {filteredData.length === 0 && !loading ? (
                            <div className="text-center py-12">
                                <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                    <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                    </svg>
                                </div>
                                <h3 className="text-lg font-medium text-gray-900 mb-2">No packages found</h3>
                                <p className="text-gray-500">Try adjusting your search terms</p>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {filteredData.map((item, index) => (
                                    <div
                                        key={item.id || index}
                                        className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl p-6 border border-white/20 transform hover:scale-105 hover:shadow-2xl transition-all duration-300 cursor-pointer animate-slide-up"
                                        style={{ animationDelay: `${index * 0.1}s` }}
                                        onClick={() => handlePackageSelect(item)}
                                    >
                                        <div className="text-center">
                                            {/* Package Icon */}
                                            <div className="w-16 h-16 bg-[#a8e82f] rounded-2xl flex items-center justify-center mx-auto mb-4">
                                                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                                </svg>
                                            </div>

                                            {/* Package Name */}
                                            <h3 className="text-xl font-bold text-gray-800 mb-2">{item?.name}</h3>

                                            {/* Package Description */}
                                            {item?.description && (
                                                <p className="text-gray-600 text-sm mb-4 line-clamp-2">{item.description}</p>
                                            )}

                                            {/* Package Price */}
                                            <div className="mb-6">
                                                <span className="text-4xl font-bold text-gray-600">${item?.price}</span>
                                                <span className="text-gray-500 text-sm ml-1">/ month</span>
                                            </div>

                                            {/* Features */}
                                            {/* {item?.features && (
                        <div className="mb-6 space-y-2">
                          {item?.features?.slice(0, 3)?.map((feature, idx) => (
                            <div key={idx} className="flex items-center text-sm text-gray-600">
                              <svg className="w-4 h-4 text-lime-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                              </svg>
                              {feature}
                            </div>
                          ))}
                        </div>
                      )} */}

                                            {/* Select Button */}
                                            <button
                                                className="w-full bg-[#a8e82f] text-black py-3 px-6 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handlePackageSelect(item);
                                                }}
                                            >
                                                Select Package
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Loading indicator */}
                    {loading && (
                        <div className="flex justify-center py-8">
                            <div className="flex items-center space-x-2 text-gray-600">
                                <div className="w-6 h-6 border-2 border-gray-600 border-t-transparent rounded-full animate-spin"></div>
                                <span className="font-medium">Loading more packages...</span>
                            </div>
                        </div>
                    )}

                    {/* No more data indicator */}
                    {!loading && !hasMore && data.length > 0 && (
                        <div className="text-center py-8">
                            <p className="text-gray-500">No more packages to load</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Package;